var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.02344 3.47767C3.02344 0.843291 6.40468 -0.719208 8.3953 1.73079C6.84218 2.34329 5.46718 4.28079 6.05468 6.44642C6.0453 6.44642 6.03593 6.44798 6.02655 6.44954C6.01718 6.4511 6.0078 6.45267 5.99843 6.45267C4.35468 6.45267 3.02344 5.12142 3.02344 3.47767ZM12.9734 5.47766C12.9734 7.1207 11.6415 8.45265 9.99843 8.45265C8.35539 8.45265 7.02344 7.1207 7.02344 5.47766C7.02344 3.83461 8.35539 2.50266 9.99843 2.50266C11.6415 2.50266 12.9734 3.83461 12.9734 5.47766ZM15.9484 13.8995C15.9484 17.3682 4.05469 17.3682 4.05469 13.8995C4.05469 7.76821 15.9484 7.83071 15.9484 13.8995ZM6.39923 7.34641C0.905481 6.59328 -2.62577 12.9683 2.53048 14.0558C2.58048 11.1277 4.80548 9.34641 7.52736 8.69016C7.05861 8.33078 6.67423 7.87453 6.39923 7.34641Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.74dffd9c2041d13a2ca305459b758a1d.svg";
export { ForwardRef as ReactComponent };